export default "__VITE_ASSET__HiGKh6fJ__"